import React, { useEffect } from "react";
import { Stack } from "@mui/material";
import Paper from "@mui/material/Paper";
import _ from "lodash";
import "../../context_dark.css";
import { StyledAutocompleteDark } from "../../context_components/styled_autocomplete";
import { alpha, styled } from '@mui/material/styles';
import { analysisActions } from "../../../store/store";
import { useDispatch, useSelector } from "react-redux";
import TextField from "@mui/material/TextField";
import { Chip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Selector from "../../context_components/selector";
import { AnalysisOptions } from "./analysisOptions";
import { Collapse } from "@mui/material";

export default function LinearAnalysis(props) {
  const {
    skuInfoRaw,
    brands,
    variants,
    skus
  } = useSelector(state => state.defaultTabStore);
  const {
    linearAnalysis,
    analysisOptions
  } = useSelector(state => state.analysisStore);
  const {
    color,
    col_100
  } = useSelector(state => state.themeStore);
  const aiStatus = analysisOptions.AI.selected;
  const hiStatus = analysisOptions.HI.selected;
 
  const StyledChip = styled(Chip)(({ theme }) => ({
    backgroundColor: col_100,
    color: "rgba(245, 245, 245, 0.75)"
  }));

  const useAutoCompleteStyles = makeStyles({ 
    option: {
      fontSize: '0.875rem',
    },
  });
  
  const dispatch = useDispatch();
  const autocomplete_classes = useAutoCompleteStyles();

  const handleLinearAnlaysisOptionChange = (e, type) => {
    /**
     * reverting colors object to initial state, 
     * if all options are de selected.
     * if selected options are not empty, 
     * it'll update the analysis store according to selected type
     */
    if (e.length === 0) {
      dispatch(analysisActions.removeOption({
        analysis: "linearAnalysis",
        value: [],
        currentSelectedType: linearAnalysis.currentSelectedType,
        colors: {}
      }));
    }
    
    if (type === "brands") {
      dispatch(analysisActions.updateOptions({
        analysis: "linearAnalysis",
        type: "selectedBrands",
        value: e,
        currentSelectedType: "selectedBrands"
      }));

      // deselecting other options
      dispatch(analysisActions.updateOptions({
        analysis: "linearAnalysis",
        type: "selectedVariants",
        value: [],
        currentSelectedType: "selectedBrands"
      }));
      dispatch(analysisActions.updateOptions({
        analysis: "linearAnalysis",
        type: "selectedSkus",
        value: [],
        currentSelectedType: "selectedBrands"
      }));
    } else if (type === "variants") {
      dispatch(analysisActions.updateOptions({
        analysis: "linearAnalysis",
        type: "selectedVariants",
        value: e,
        currentSelectedType: "selectedVariants"
      }));

      // deselecting other options
      dispatch(analysisActions.updateOptions({
        analysis: "linearAnalysis",
        type: "selectedBrands",
        value: [],
        currentSelectedType: "selectedVariants"
      }));
      dispatch(analysisActions.updateOptions({
        analysis: "linearAnalysis",
        type: "selectedSkus",
        value: [],
        currentSelectedType: "selectedVariants"
      }));
    } else if (type === "skus") {
      dispatch(analysisActions.updateOptions({
        analysis: "linearAnalysis",
        type: "selectedSkus",
        value: e,
        currentSelectedType: "selectedSkus"
      }));

      // deselecting other options
      dispatch(analysisActions.updateOptions({
        analysis: "linearAnalysis",
        type: "selectedVariants",
        value: [],
        currentSelectedType: "selectedSkus"
      }));
      dispatch(analysisActions.updateOptions({
        analysis: "linearAnalysis",
        type: "selectedBrands",
        value: [],
        currentSelectedType: "selectedSkus"
      }));
    }
  }

  const handleRemoveOption = (item) => {
    /**
     * removing color against selected item from color object
     * simultaneously updating the selected values object by current selected type
     */
    const colors = {...linearAnalysis.colors};
    delete colors[item];
    dispatch(analysisActions.removeOption({
      analysis: "linearAnalysis",
      value: linearAnalysis[linearAnalysis.currentSelectedType].filter(r => r !== item),
      currentSelectedType: linearAnalysis.currentSelectedType,
      colors: colors
    }));
  }

  const renderSelectedOptions = (selectedOptions, { inputValue }) => {
    /**
     * The delete option in the chip is not configured (yet...)
     */
    let displayedOptions = selectedOptions.slice(0, 0);

    if (selectedOptions.length > 0) {
      const remainingCount = selectedOptions.length;
      const remainingOptions = `+${remainingCount}`;
      displayedOptions = displayedOptions.concat(remainingOptions);
    }

    return (
      <div>
        {displayedOptions.map((option, index) => (
          <StyledChip
            // className={chip_classes.chip}
            size="small"
            key={index}
            label={option}
            onDelete={() => handleLinearAnlaysisOptionChange(option, "")}
          />
        ))}
      </div>
    );
  };

  // this determines which type of options to display
  const currentSelection = linearAnalysis[linearAnalysis.currentSelectedType];

  return (
    <Stack
      spacing={2}
      sx={{ dispaly: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Stack spacing={0}>
        {brands.length > 0 &&
          <StyledAutocompleteDark
            sx={{ width: "15rem" }}
            classes={{
              option: autocomplete_classes.option,
            }}
            id="size-small-outlined-multi"
            size="small"
            noOptionsText="Loading..."
            value={linearAnalysis.selectedBrands}
            componentsProps={{ popper: { style: { width: 'fit-content' } } }}
            options={brands}
            getOptionLabel={(option) => option}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" placeholder={`Brands   ( ${brands.length} )`} />
            )}
            renderTags={renderSelectedOptions}
            multiple
            onChange={(event, values) => handleLinearAnlaysisOptionChange(values, "brands")}
          />}

        {variants.length > 0 &&
          <StyledAutocompleteDark
            sx={{ width: "15rem" }}
            classes={{
              option: autocomplete_classes.option,
            }}
            id="size-small-outlined-multi"
            size="small"
            noOptionsText="Loading..."
            value={linearAnalysis.selectedVariants}
            componentsProps={{ popper: { style: { width: 'fit-content' } } }}
            options={variants}
            getOptionLabel={(option) => option}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" placeholder={`Variants   ( ${variants.length} )`} />
            )}
            renderTags={renderSelectedOptions}
            multiple
            onChange={(event, values) => handleLinearAnlaysisOptionChange(values, "variants")}
          />}

        {skus.length > 0 &&
          <StyledAutocompleteDark
            sx={{ width: "15rem" }}
            classes={{
              option: autocomplete_classes.option,
            }}
            id="size-small-outlined-multi"
            size="small"
            noOptionsText="Loading..."
            value={linearAnalysis.selectedSkus}
            componentsProps={{ popper: { style: { width: 'fit-content' } } }}
            options={skus}
            getOptionLabel={(option) => option}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" placeholder={`SKUs   ( ${skus.length} )`} />
            )}
            renderTags={renderSelectedOptions}
            multiple
            onChange={(event, values) => handleLinearAnlaysisOptionChange(values, "skus")}
          />}
      </Stack> 

      {currentSelection && currentSelection.map(item => (
        <Selector 
          type="linearAnalysis"
          value={item} 
          onClick={handleRemoveOption}
        />
      ))}

      {/* Analysis Options */}
      <Collapse in={hiStatus} timeout={350} unmountOnExit>
        <AnalysisOptions />
      </Collapse>
    </Stack>
  )
}